var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResourcesCpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 5.333H1v14.444a2.242 2.242 0 00.644 1.572A2.199 2.199 0 003.2 22h16.5v-2.223H3.2V5.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 5.333h-5.5L13.484 2.89a2.189 2.189 0 00-1.76-.89H7.6a2.19 2.19 0 00-1.556.652A2.234 2.234 0 005.4 4.223v11.11c0 .59.231 1.155.644 1.572.413.417.972.65 1.556.65h13.2a2.19 2.19 0 001.555-.65c.413-.417.645-.982.645-1.572V7.556c0-.59-.232-1.155-.645-1.572a2.19 2.19 0 00-1.555-.65zm-13.2 10V4.223h4.125l1.815 2.444a2.212 2.212 0 001.76.889h5.5v7.777H7.6z"
  })));
}
export default SvgIconResourcesCpt;